import { Edit, useNotify, useRedirect, useTranslate } from 'react-admin'
import FormInput from './FormInput'
import {useSearchParams} from "react-router-dom"

const UserEdit = () => {
  const translate = useTranslate()
  const redirect = useRedirect()
  const notify = useNotify()
  const [searchParams] = useSearchParams()

  var resource = searchParams.get("resource")

  const onSuccess = (data?: {id: string}) => {
    notify('Nutzerdaten wurden aktualisiert', {
      messageArgs: { smart_count: 1 }
    })
    resource === "invoices" ? redirect("create", "invoices") : redirect("show", "users", data?.id)
  }

  return (
    <Edit mutationOptions={{ onSuccess }} mutationMode={"pessimistic"} title={translate("resources.users.name", {smart_count: 1})}>
      <FormInput />
    </Edit>
  )
}

export default UserEdit